import React from 'react';

import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

export default () => {
  return <TableHead>
    <TableRow>
      <TableCell>ID</TableCell>
      <TableCell>NAME</TableCell>
      <TableCell>USERNAME</TableCell>
      <TableCell>EMAIL</TableCell>
      <TableCell>ENABLED</TableCell>
      <TableCell>ROLES</TableCell>
      <TableCell></TableCell>
    </TableRow>
  </TableHead>
}
